/**
 * Created by mauget on 1/20/16.
 */

import $        from 'jquery';
import {View} from 'backbone';
import constants        from 'Constants';
import listService      from 'ListService';
import LayoutMenuModel  from 'LayoutMenuModel';
import LayoutMenuView   from 'LayoutMenuView';
import BehaviorMenuView   from 'BehaviorMenuView';
import WorkflowMenuView   from 'WorkflowMenuView';
import ReportMenuView   from 'ReportMenuView';
import MobileMenuView   from 'MobileMenuView';
import factoryService  from 'FactoryService';
import pageCollection from 'PageCollection';
import PageView 		from 'form/PageView';
import ToolbarPaneView from 'ToolbarPaneView';
import MobileToolbarPaneView from 'MobileToolbarPaneView';
import ToolbarPaneModel from 'ToolbarPaneModel';
import ToolboxPaneView from 'ToolboxPaneView';
import ToolboxPaneModel from 'ToolboxPaneModel';
import EditorContentView from 'designer/EditorContentView';
import EditorContentModel from 'EditorContentModel';
import BehaviorToolboxPaneView from 'BehaviorToolboxPaneView';
import BehaviorToolboxPaneModel from 'BehaviorToolboxPaneModel';
import BehaviorToolbarPaneView from 'behaviors/BehaviorToolbarPaneView';
import WorkflowToolbarPaneView from 'workflow/WorkflowToolbarPaneView';
import ReportToolbarPaneView from 'report/ReportToolbarPaneView';
import viewManagerService   from 'ViewManagerService';

//=============================================================================
//
// An "abstract" class that underlies the several main panels. Used for
// common methods, ect.
//
// -Lou Mauget, December 5, 2015
//
//=============================================================================
class BaseMainView extends View {
    formView;
    pageView;
    behaviorToolbarPaneView;
    workflowToolbarPaneView;
    reportToolbarPaneView;
    layoutMenuView;
    toolbarPaneView;

    //==========================================================
    // Create the nav meneu above the layout / canvas area
    // kind is one of: 'L', 'B', 'W', or 'R'.
    // ... their manifest constants are:
    //  KIND_LAYOUT()
    //  TITLE_BEHAVIORS()
    //  TITLE_WORKFLOW()
    //  TITLE_REPORT()
    //==========================================================
    initMenu(kind) {

        const titles = {'L': 'Layout', 'B': 'Behaviors', 'W': 'Workflow', 'R': 'Report'};

        const attributes = {
            'editType': titles[kind],
            'lActive': kind === constants.KIND_LAYOUT ? constants.NAV_BUTTON_ACTIVE : constants.NAV_BUTTON_INACTIVE,
            'bActive': kind === constants.KIND_BEHAVIORS ? constants.NAV_BUTTON_ACTIVE : constants.NAV_BUTTON_INACTIVE,
            'wActive': kind === constants.KIND_WORKFLOW ? constants.NAV_BUTTON_ACTIVE : constants.NAV_BUTTON_INACTIVE,
            'rActive': kind === constants.KIND_REPORT ? constants.NAV_BUTTON_ACTIVE : constants.NAV_BUTTON_INACTIVE
        };

        LayoutMenuModel.set(attributes, {silent:true});
        //console.log(LayoutMenuModel.attributes);


        this.layoutMenuView = (function getMenuView (menuVariant ) {
            let menuView;
            const options = {
                model: LayoutMenuModel,
                el: constants.MENU_ANCHOR_ID
            };

            // Note: forces report menu on any kind, if docType is REPORT
            switch (menuVariant) {

                case constants.KIND_MOBILE:

                    /*TODO: Change this to the right Class Menu for Mobile. 
                            When the Winter comes and Cersei has taken the throne.*/
                    menuView = new MobileMenuView( options );
                     
                    break;

                case constants.KIND_LAYOUT:

                    if (listService.docType === constants.DOC_TYPE_REPORT) {
                        menuView = new ReportMenuView( options );
                    } else if (listService.docType === constants.DOC_TYPE_FORM) {
                        menuView = new LayoutMenuView( options );
                    } else {
                        throw Exception('Panic 1. Unknown document type.');
                    }
                    break;

                case constants.KIND_BEHAVIORS:

                    if (listService.docType === constants.DOC_TYPE_REPORT) {
                        menuView = new BehaviorMenuView( options );
                    } else if (listService.docType === constants.DOC_TYPE_FORM) {
                        menuView = new BehaviorMenuView({
                            model: LayoutMenuModel,
                            el: constants.MENU_ANCHOR_ID
                        });
                    } else {
                        throw Exception('Panic 1. Unknown document type.');
                    }
                    break;

                // Reports don't do workflow
                case constants.KIND_WORKFLOW:

                    menuView = new WorkflowMenuView( options );
                    break;

                case constants.KIND_REPORT:

                    menuView = new ReportMenuView( options );
                    // Reports are always ... uhm ... reports
                    // listService.setDocTypeReport();
                    break;
            }
            return menuView;
        })( kind );

        // For context-sensitive help ...
        listService.mainKind = kind;

        viewManagerService.renderMenuView(this.layoutMenuView);
//        layoutMenuView.render();
    }

    //==========================================================
    // Helper:
    // Impose well-known DOM IDs for use by Q/A test automation.
    // JQuery is our friend. Caller determines the selector
    // and ID prefxi. The suffix is sequential run of integers.
    //==========================================================
    injectTestIds(selector, prefix) {

        $(selector).each((index, element) => {
            $(element).attr('id', `${prefix}${index}`);
        });

    }

    //==========================================================
    // Insert Toolbar Pane.
    //==========================================================
    initToolbarPane() {

        const attributes = {};

        if (this.options.designer  && this.options.designer === constants.KIND_MOBILE) {
            this.toolbarPaneView = new MobileToolbarPaneView(
                {model: new ToolbarPaneModel(attributes), el: constants.TOOLBAR_PANE_ID});
        }
        else {
            this.toolbarPaneView = new ToolbarPaneView(
                {model: new ToolbarPaneModel(attributes), el: constants.TOOLBAR_PANE_ID});
        }
       

        viewManagerService.renderToolbarPaneView(this.toolbarPaneView);
    }

    //==========================================================
    // Insert Toolbox Pane.
    //==========================================================
    xx_initToolboxPane() {

        const attributes = {};
        const toolboxPaneView = new ToolboxPaneView(
            {model: new ToolboxPaneModel(attributes), el: constants.TOOLBOX_PANE_ID});

        toolboxPaneView.render();


    }

    //==========================================================
    // Insert Behavior Toolbox Pane.
    //==========================================================
    xx_initBehaviorToolboxPane() {

        const attributes = {};
        const behaviorToolboxPaneView = new BehaviorToolboxPaneView(
            {model: new BehaviorToolboxPaneModel(attributes), el: constants.TOOLBOX_PANE_ID});

        behaviorToolboxPaneView.render();


    }

    initBehaviorToolbarPane() {
        const attributes = {};
        this.behaviorToolbarPaneView = new BehaviorToolbarPaneView(
            {model: new ToolbarPaneModel(attributes), el: constants.TOOLBAR_PANE_ID});

        viewManagerService.renderToolbarPaneView(this.behaviorToolbarPaneView);
    }

    initWorkflowToolbarPane() {
        const attributes = {};
        this.workflowToolbarPaneView = new WorkflowToolbarPaneView(
            {model: new ToolbarPaneModel(attributes), el: constants.TOOLBAR_PANE_ID});

        viewManagerService.renderToolbarPaneView(this.workflowToolbarPaneView);
    }

    initReportToolbarPane() {
        const attributes = {};
        this.reportToolbarPaneView = new ReportToolbarPaneView(
            {model: new ToolbarPaneModel(attributes), el: constants.TOOLBAR_PANE_ID});

        viewManagerService.renderToolbarPaneView(this.reportToolbarPaneView);
    }

    initEditorContent(kind, formProperties) {
        //console.log('initEditorContent at ' + Date());

        const attributes = {};
        attributes.mode = kind;
        const editorContentView = new EditorContentView(
            {model: new EditorContentModel(attributes), el: constants.EDITOR_CONTENT_ID});
        viewManagerService.renderEditorView(editorContentView);

        const pageKeys = {'L': 'layout_page', 'M': 'layout_page', 'B': 'behaviors_page', 'W': 'workflow_page', 'R': 'report_page'};

        let factoryFormKey = 'layout_frame';
        const factoryPageKey = pageKeys[kind];

        let factoryParamP;
        let factoryParamF;

        /*
        if (listService.currentForm) {
            listService.currentForm.remove();
        }
        */

        /* On this conditional we require to handle the view switch between layout,behavior and workflow views.
         * The factory pageKey is being given by the constant provided in the Workflow View and searching it in the pageKeys object.
         * */
        if (factoryPageKey === 'workflow_page') {
            factoryFormKey = 'workflow_frame';

            // We must call factories created for workflow in the FactoryService. Behavior view should have their owns as well.
            factoryParamP = factoryService.workflowFactories[factoryPageKey];
            factoryParamF = factoryService.workflowFactories[factoryFormKey];
        } else if (factoryPageKey === 'behaviors_page') {
            factoryFormKey = 'behaviors_frame';

            factoryParamP = factoryService.behaviorsFactories[factoryPageKey];
            factoryParamF = factoryService.behaviorsFactories[factoryFormKey];
        } else if (factoryPageKey === 'report_page') {
            factoryFormKey = 'reports_frame';

            factoryParamP = factoryService.factories[factoryPageKey];
            factoryParamF = factoryService.factories[factoryFormKey];
        }
        else {
            factoryParamP = factoryService.factories[factoryPageKey];
            factoryParamF = factoryService.factories[factoryFormKey];
        }

        if ((factoryPageKey === 'layout_page' || factoryPageKey === 'report_page') && pageCollection.models.length > 0) {
            this.pageView = new PageView( { model: pageCollection.models[0], el: $(constants.FORM_ID) }); 
        } else { 
            this.pageView = factoryParamP.factory.createView(factoryPageKey);
        }

        this.formView = factoryParamF.factory.createView(factoryFormKey, formProperties);

        if (listService.currentForm) {
            if (!listService.currentForm.model.get('mobileOutsideColor')) {
                listService.currentForm.model.set('mobileOutsideColor',
                    listService.currentForm.model.get('outsideColor'),
                    constants.MODEL_SILENT);
            }
            let formModel = listService.currentForm.model;
            this.formView.model = formModel;
        }

        //listService.currentForm = formView;
        //listService.currentForm.model.set('currentLayout', 'desktopLayout', {silent:true});
        this.formView.model.set('currentLayout', 'desktopLayout', {silent:true});

        listService.isDraggingCp = false;

        viewManagerService.renderFormView(this.formView);
        viewManagerService.renderPageView(this.pageView);

    }

    removeUnused() {
        if (listService.currentForm) {
        listService.currentForm.remove();
        }
        
        if(this.behaviorToolbarPaneView){
            this.behaviorToolbarPaneView.remove();
        }
        if(this.workflowToolbarPaneView){
            this.workflowToolbarPaneView.remove();
        }
        if(this.reportToolbarPaneView){
            this.reportToolbarPaneView.remove();
        }
        if(this.layoutMenuView){
            this.layoutMenuView.remove();
        }
        if(this.pageView){
            this.pageView.remove();
        }
        if(this.formView){
            this.formView.remove();        
        }
        if(this.toolbarPaneView){
            this.toolbarPaneView.remove();
        }
    }

    remove(){
        this.removeUnused();
        super.remove();
    }

}
export default BaseMainView;

